import { CanDeactivateFn } from '@angular/router';
import { IUnsavedChangesGuarded } from '../models';

export const unsavedChangesGuard: CanDeactivateFn<IUnsavedChangesGuarded> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => component?.confirmLeave(nextState.url) ?? true;
